import React, { useState, useEffect, useRef } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import BaseSelect from 'components/baseSelect';
import InputMask from "react-input-mask";

const Swal = require('sweetalert2');

const VehicleForm = ({errors, touched, handleChange, values, element, removeVehicleForm, options, setFieldValue, displayShortName}) => {
    // const [modeloId, setModeloId] = useState(values[`model_${element.id}`]);
    const onRemoveForm = () => removeVehicleForm(element.id);
    const FourMB = 4e+6;

    const operationNotAllowed = () => {
        Swal.fire({
            icon: 'warning',
            title: '¡Atención!',
            text: '¡La imagen no puede exceder los 4 MB!'
        });
    }

    const validateMB = (file) => {
        if (!file) {
            return false;
        }

        if (file.size <= FourMB) {
            return true;
        } else {
            operationNotAllowed();
        }
    }

    const trimDocTitle = (docTitle, lenght = 30) => {
        if (docTitle.length > lenght) {
            return docTitle.substring(0, lenght) + "...";
        }
        return docTitle
    }

    const getFileName = (value) => {
        if (!value) {
            return null;
        }

        if (typeof value === 'string') {
            return value;
        }

        return value.name || null;
    }

    return (
        <>
            <BaseSelect
              md={3}
              errors={errors}
              touched={touched}
              handleChange={handleChange}
              values={values}
              label={'Tipo de Documento *'}
              name={`documentoId_${element.id}`}
              url={'DocumentoTipo'}
            />

            <Form.Group as={Col} md="3" controlId={"validationfile_" + element.id}>
                <Form.Label>Archivo *</Form.Label>
                <Form.File
                    name={`file_${element.id}_`}
                    label={
                        (() => {
                            const fileName = getFileName(values[`file_${element.id}_`]);
                            if (!fileName) {
                                return displayShortName ? 'Seleccione ' : 'Seleccione un documento';
                            }

                            return displayShortName
                                ? trimDocTitle(fileName, 5)
                                : trimDocTitle(fileName);
                        })()
                    }
                    onChange={(event) => {
                        if (validateMB(event.currentTarget.files[0])) {
                            setFieldValue(`file_${element.id}_`, event.currentTarget.files[0]);
                        }
                    }}
                    //isValid={touched[`file_${element.id}`] && !errors[`file_${element.id}`]}
                    isInvalid={!!errors[`file_${element.id}_`]}
                    custom
                />
                <Form.Control.Feedback type="invalid">
                    {errors[`file_${element.id}_`]}
                </Form.Control.Feedback>
            </Form.Group>
                 
            <Form.Group as={Col} md="6" style={{marginTop: 31}}>
                <Button onClick={onRemoveForm} variant="outline-primary"><i className="fas fa-trash-alt"></i></Button>
            </Form.Group>
        </>
    )
}

export default VehicleForm;